(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ld-card-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ld-card-carousel')) {
    customElements.define('ld-card-carousel', class extends HTMLElement {
      connectedCallback() {
        this.rail = this.querySelector('[data-cc-rail]');
        this.prev = this.querySelector('[data-cc-dir="prev"]');
        this.next = this.querySelector('[data-cc-dir="next"]');
        if (!this.rail) return;
        const self = this;
        if (this.prev) this.prev.addEventListener('click', function () { self.scrollByCard(-1); });
        if (this.next) this.next.addEventListener('click', function () { self.scrollByCard(1); });
        this.rail.addEventListener('scroll', function () { self.update(); }, { passive: true });
        window.addEventListener('resize', function () { self.update(); }, { passive: true });
        this.update();
      }
      cardStep() {
        const card = this.rail.querySelector('.ld-cc__card');
        if (!card) return 300;
        const gap = parseFloat(getComputedStyle(this.rail).columnGap || getComputedStyle(this.rail).gap || '16') || 16;
        return card.getBoundingClientRect().width + gap;
      }
      scrollByCard(dir) {
        this.rail.scrollBy({ left: dir * this.cardStep(), behavior: 'smooth' });
      }
      update() {
        const r = this.rail;
        const overflowing = r.scrollWidth - r.clientWidth > 1;
        this.setAttribute('data-show-arrows', overflowing ? 'true' : 'false');
        if (this.prev) this.prev.disabled = r.scrollLeft <= 1;
        if (this.next) this.next.disabled = r.scrollLeft >= (r.scrollWidth - r.clientWidth - 1);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ld-header"] && !Shopify.designMode) return;
  try {
    
  /* ld-header section-scoped behaviour:
     - Set --ld-header-height to the rendered shell offsetHeight on
       mount + ResizeObserver updates.
     - Toggled-fixed sticky: pre-pin -> relative; post-pin -> fixed via
       data-pinned. scroll-up reveal toggles data-state.
     Pattern 27: this block must NOT contain shipped Horizon section
     type-name substrings. All identifiers use neutral terms. */
  class LDHeaderShell extends HTMLElement {
    connectedCallback() {
      this._setHeightVar();

      // Capture natural offsetTop BEFORE any pinning so the threshold
      // accounts for upstream peer sections (e.g. promo strip above).
      this._upstreamOffset = this.offsetTop || 0;
      this._lastScrollY = window.scrollY;
      this._scrollHandler = this._onScroll.bind(this);

      if (this.dataset.stickyMode && this.dataset.stickyMode !== 'none') {
        window.addEventListener('scroll', this._scrollHandler, { passive: true });
        this._onScroll();
      }

      if (typeof ResizeObserver !== 'undefined') {
        this._ro = new ResizeObserver(() => {
          this._setHeightVar();
          if (this.dataset.pinned !== 'true') {
            this._upstreamOffset = this.offsetTop || 0;
          }
        });
        this._ro.observe(this);
      }
    }

    disconnectedCallback() {
      if (this._scrollHandler) {
        window.removeEventListener('scroll', this._scrollHandler);
      }
      if (this._ro) this._ro.disconnect();
    }

    _setHeightVar() {
      document.documentElement.style.setProperty(
        '--ld-header-height',
        this.offsetHeight + 'px'
      );
    }

    _onScroll() {
      const y = window.scrollY;
      const threshold = this._upstreamOffset || 0;
      const shouldPin = y > threshold;

      if (shouldPin) {
        this.dataset.pinned = 'true';
        if (this.dataset.stickyMode === 'scroll-up' || this.dataset.stickyMode === 'always-collapse-nav') {
          const dir = y > this._lastScrollY ? 'down' : 'up';
          if (dir === 'down' && y > threshold + 80) {
            this.dataset.state = 'hidden';
          } else if (dir === 'up') {
            this.dataset.state = 'visible';
          }
        } else {
          this.dataset.state = 'visible';
        }
      } else {
        delete this.dataset.pinned;
        this.dataset.state = 'visible';
      }

      this._lastScrollY = y;
    }
  }

  if (!customElements.get('ld-header')) {
    customElements.define('ld-header', LDHeaderShell);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ld-inspiration-block"] && !Shopify.designMode) return;
  try {
    
  /* ld-inspiration-block: horizontal-carousel nav. Reveals dark square caret
     arrows when the cards row overflows (more articles than visible columns)
     and scrolls one card per click. Pure DOM — no data fetching. */
  (function () {
    if (customElements.get('ld-inspiration-carousel')) return;

    customElements.define('ld-inspiration-carousel', class extends HTMLElement {
      constructor() {
        super();
        this.__listeners = [];
      }

      connectedCallback() {
        var self = this;
        this.__cards = this.querySelector('[data-ld-cards]');
        this.__prev = this.querySelector('[data-ld-nav="prev"]');
        this.__next = this.querySelector('[data-ld-nav="next"]');
        if (!this.__cards) return;

        this.__add(this.__prev, 'click', function () { self.__scroll(-1); });
        this.__add(this.__next, 'click', function () { self.__scroll(1); });
        this.__add(this.__cards, 'scroll', function () { self.__update(); });
        this.__onResize = function () { self.__update(); };
        window.addEventListener('resize', this.__onResize);

        this.__update();
      }

      disconnectedCallback() {
        this.__listeners.forEach(function (e) {
          if (e.t && e.h) e.t.removeEventListener(e.ev, e.h);
        });
        this.__listeners = [];
        if (this.__onResize) window.removeEventListener('resize', this.__onResize);
      }

      __add(target, ev, handler) {
        if (!target) return;
        target.addEventListener(ev, handler);
        this.__listeners.push({ t: target, ev: ev, h: handler });
      }

      __scroll(dir) {
        var item = this.__cards.querySelector('.ld-inspiration-card');
        var w = item ? item.getBoundingClientRect().width : (this.__cards.clientWidth / 3);
        var styles = getComputedStyle(this.__cards);
        var gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
        this.__cards.scrollBy({ left: dir * (w + gap), behavior: 'smooth' });
      }

      __update() {
        var c = this.__cards;
        var overflowing = c.scrollWidth - c.clientWidth > 1;
        this.setAttribute('data-show-arrows', overflowing ? 'true' : 'false');
        if (this.__prev) this.__prev.disabled = c.scrollLeft <= 1;
        if (this.__next) {
          this.__next.disabled = c.scrollLeft >= (c.scrollWidth - c.clientWidth - 1);
        }
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ld-product-carousel-tabs"] && !Shopify.designMode) return;
  try {
    
  /* ld-product-carousel-tabs: desktop horizontal-carousel nav. Each tab panel is
     an independent scroll track; dark square caret arrows appear when a track
     overflows (more products than visible columns) and scroll one card per click.
     Because the tabs keep every panel in the DOM (CSS `:has(:checked)` switching),
     hidden panels report a 0 client-width — so arrows are recomputed whenever the
     active tab changes. Pure DOM, no data fetching. */
  (function () {
    if (customElements.get('ld-product-carousel-tabs')) return;

    customElements.define('ld-product-carousel-tabs', class extends HTMLElement {
      connectedCallback() {
        var self = this;
        this.__listeners = [];
        this.__units = [];

        var wraps = this.querySelectorAll('[data-ld-cards-wrap]');
        Array.prototype.forEach.call(wraps, function (wrap) {
          var cards = wrap.querySelector('[data-ld-cards]');
          if (!cards) return;
          var unit = {
            wrap: wrap,
            cards: cards,
            prev: wrap.querySelector('[data-ld-nav="prev"]'),
            next: wrap.querySelector('[data-ld-nav="next"]')
          };
          self.__units.push(unit);
          self.__add(unit.prev, 'click', function () { self.__scroll(unit, -1); });
          self.__add(unit.next, 'click', function () { self.__scroll(unit, 1); });
          self.__add(cards, 'scroll', function () { self.__update(unit); });
        });

        /* Recompute the newly-visible panel when the active tab changes. */
        var radios = this.querySelectorAll('.ld-pct__radio');
        Array.prototype.forEach.call(radios, function (radio) {
          self.__add(radio, 'change', function () { self.__updateAll(); });
        });

        this.__onResize = function () { self.__updateAll(); };
        window.addEventListener('resize', this.__onResize);

        this.__updateAll();
      }

      disconnectedCallback() {
        this.__listeners.forEach(function (e) {
          if (e.t && e.h) e.t.removeEventListener(e.ev, e.h);
        });
        this.__listeners = [];
        if (this.__onResize) window.removeEventListener('resize', this.__onResize);
      }

      __add(target, ev, handler) {
        if (!target) return;
        target.addEventListener(ev, handler);
        this.__listeners.push({ t: target, ev: ev, h: handler });
      }

      __scroll(unit, dir) {
        var item = unit.cards.firstElementChild;
        var w = item ? item.getBoundingClientRect().width : (unit.cards.clientWidth / 3);
        var styles = getComputedStyle(unit.cards);
        var gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
        unit.cards.scrollBy({ left: dir * (w + gap), behavior: 'smooth' });
      }

      __update(unit) {
        var c = unit.cards;
        var overflowing = c.scrollWidth - c.clientWidth > 1;
        unit.wrap.setAttribute('data-show-arrows', overflowing ? 'true' : 'false');
        if (unit.prev) unit.prev.disabled = c.scrollLeft <= 1;
        if (unit.next) {
          unit.next.disabled = c.scrollLeft >= (c.scrollWidth - c.clientWidth - 1);
        }
      }

      __updateAll() {
        var self = this;
        this.__units.forEach(function (u) { self.__update(u); });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ld-recently-viewed"] && !Shopify.designMode) return;
  try {
    
  /* ld-recently-viewed: client-side hydration from localStorage 'viewedProducts'.
     Reads stored IDs, resolves handles via /products/<id> redirect, fetches each
     product's JSON via /products/<handle>.js, then mutates the existing
     server-rendered card DOM in place. Hides the section if no eligible
     recently-viewed products remain after excluding the current PDP product. */

  (function () {
    if (window.__ldRecentlyViewedRegistered__) return;
    window.__ldRecentlyViewedRegistered__ = true;

    var STORAGE_KEY = 'viewedProducts';

    function readViewedIds() {
      try {
        var raw = localStorage.getItem(STORAGE_KEY);
        if (!raw) return [];
        var parsed = JSON.parse(raw);
        if (!Array.isArray(parsed)) return [];
        return parsed.map(function (v) { return String(v); });
      } catch (e) {
        return [];
      }
    }

    /* Fetch the section, re-rendered by Shopify for the viewed products.
       There is no storefront route from a product ID to a product — `/products/{id}` is a 404 and
       Liquid cannot look one up by ID — so the IDs go through the SEARCH INDEX as
       `?q=id:123 OR id:456`, which is what Horizon's own predictive-search empty state does
       (assets/predictive-search.js). Asking for `section_id` means Shopify renders the real cards
       in each product's OWN context, so the hover specs, badges and prices belong to the product
       they are shown on. */
    function fetchViewedSection(host, ids) {
      if (!ids.length) return Promise.resolve(null);
      var sectionId = host.getAttribute('data-section-id');
      if (!sectionId) return Promise.resolve(null);
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      var url = new URL(root.replace(/\/$/, '') + '/search', window.location.origin);
      url.searchParams.set('q', ids.map(function (id) { return 'id:' + id; }).join(' OR '));
      url.searchParams.set('resources[type]', 'product');
      url.searchParams.set('section_id', sectionId);

      return fetch(url.toString())
        .then(function (r) { return r.ok ? r.text() : null; })
        .then(function (html) {
          if (!html) return null;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          return doc.querySelector('[data-ld-rv-cards]');
        })
        .catch(function () { return null; });
    }

    function hydrate(host) {
      var max = parseInt(host.getAttribute('data-max-products') || '4', 10);
      var threshold = parseInt(host.getAttribute('data-arrows-visible-threshold') || '2', 10);
      var currentId = String(host.getAttribute('data-current-product-id') || '');
      var cards = Array.prototype.slice.call(host.querySelectorAll('[data-ld-rv-card]'));

      var ids = readViewedIds();
      if (currentId) {
        ids = ids.filter(function (id) { return String(id) !== currentId; });
      }
      ids = ids.slice(0, max);

      if (ids.length === 0) {
        host.setAttribute('hidden', '');
        host.setAttribute('data-state', 'empty');
        host.setAttribute('data-card-count', '0');
        host.setAttribute('data-show-arrows', 'false');
        return Promise.resolve();
      }

      return fetchViewedSection(host, ids)
        .then(function (fresh) {
          var container = host.querySelector('[data-ld-rv-cards]');
          /* The server has already filtered to the ids we asked for, dropped the current product
             and put them in viewing order — it can, because the order is still in `search.terms`.
             So there is nothing left to do here but swap the markup in. */
          var count = fresh ? parseInt(fresh.getAttribute('data-card-total') || '0', 10) : 0;

          if (!fresh || !container || count === 0) {
            host.setAttribute('hidden', '');
            host.setAttribute('data-state', 'empty');
            host.setAttribute('data-card-count', '0');
            host.setAttribute('data-show-arrows', 'false');
            return;
          }

          /* Replace the WHOLE container, not its innerHTML. `slideshow-component` restructures its
             slides on upgrade, so swapping the inner markup leaves the previous instance's slides
             behind and the carousel ends up with a stale, empty slide between every real one. */
          var imported = document.importNode(fresh, true);
          container.replaceWith(imported);
          container = imported;
          /* These cards came back from a /search request, so Shopify stamped every product URL with
             ?_pos/_sid/_ss. Left on, each click would be reported as a search the shopper never
             made, quietly inflating search attribution. */
          Array.prototype.slice.call(container.querySelectorAll('a[href*="_sid="], a[href*="_pos="]')).forEach(function (a) {
            a.setAttribute('href', (a.getAttribute('href') || '').split('?')[0]);
          });

          /* The search index answers in relevance order; only the browser knows the order things
             were actually viewed in. Reorder the slides to match, newest first. */
          var track = container.querySelector('slideshow-slides') || container;
          var slideFor = {};
          Array.prototype.slice.call(container.querySelectorAll('slideshow-slide')).forEach(function (slide) {
            var card = slide.querySelector('[data-ld-rv-card]');
            if (card) slideFor[String(card.getAttribute('data-product-id'))] = slide;
          });
          ids.forEach(function (id) {
            var slide = slideFor[String(id)];
            if (slide) track.appendChild(slide);
          });

          host.setAttribute('data-card-count', String(count));
          host.setAttribute('data-show-arrows', count >= threshold ? 'true' : 'false');
          host.setAttribute('data-state', 'ready');
        });
    }

    if (!customElements.get('recently-viewed-section')) {
      var Klass = class extends HTMLElement {
        constructor() {
          super();
          this.__hydrated = false;
          this.__listeners = [];
          this.__onPrev = null;
          this.__onNext = null;
          this.__onMobileNext = null;
        }

        connectedCallback() {
          if (this.__hydrated) return;
          this.__hydrated = true;
          var self = this;
          hydrate(self).catch(function (e) {
            if (typeof console !== 'undefined' && console.error) {
              console.error('[ld-recently-viewed] hydration failed:', e);
            }
            self.setAttribute('hidden', '');
            self.setAttribute('data-state', 'empty');
          });
        }

        disconnectedCallback() {
          /* Detach all listeners registered in connectedCallback so SPA
             navigation / theme editor section reorder doesn't leak handlers. */
          var self = this;
          self.__listeners.forEach(function (entry) {
            if (entry.target && entry.handler) {
              entry.target.removeEventListener(entry.event, entry.handler);
            }
          });
          self.__listeners = [];
          self.__hydrated = false;
        }

      };
      customElements.define('recently-viewed-section', Klass);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
